import DeleteBusinessUnitModal from './DeleteBusinessUnitModal.component';

export default DeleteBusinessUnitModal;
